export default function operatorInfo(api){
    return api && api.provideCall && api.provideCall('requestOperatorInfo', 'cancelOperatorInfoRequest', {
        // topic to request
        rpcName: '/sports#operatorInfo',

        // validation occurs before parsing
        validateResponse: (data) => {
            const {kwargs} = data || {};
            const {providerId, apiVersion, ucsOperatorId} = kwargs || {};
            for (const param of [providerId, apiVersion, ucsOperatorId]){
                if (typeof param === 'undefined'){
                    return false;
                }
            }
            return true;
        },
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/rpc-operator-info.js